import { Component, OnInit, DoCheck, ViewChild, Input, Output, ElementRef, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";
import { MatPaginator, MatSort } from '@angular/material';
import { saveAs as importedSaveAs } from "file-saver";

import { AppComponent } from './../../../app.component';

import { Articolo } from '../../../models/Articolo';
import { ArticoloService } from './../../../services/articolo.service';
import { SharedService } from './../../../services/shared.service';
import { MatTableCustomDataSource, MatTableCustomApi, MatTableCustomDao } from './../../../helpers/mat-table-datasource';

import * as moment from 'moment';

@Component({
  selector: 'app-articolo-search',
  templateUrl: './articolo-search.component.html',
  styleUrls: ['./articolo-search.component.css'],
  providers: [ArticoloService],
  encapsulation: ViewEncapsulation.None
})
export class ArticoloSearchComponent implements OnInit {
  displayedColumns = ['anno', 'numero', 'pagina', 'free', 'codice', 'titolo', '_id'];
  articoloDatabase: MatTableCustomDao<Articolo> | null;
  dataSource: MatTableCustomDataSource<Articolo, MatTableCustomApi<Articolo>>;
  printing: boolean = false;
  @Input() nested: boolean = false;
  @Output() notify: EventEmitter<Articolo> = new EventEmitter<Articolo>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('qfilter') qfilter: ElementRef;

  wmodel: Articolo = new Articolo();

  downloadingCSVExportRL: boolean = false;

  chipselectable: boolean = true;
  filter: EventEmitter<any> = new EventEmitter<any>();
  filterModel: any = {};
  activeFilter: string;
  filters: any[] = [];

  confirm2remove: boolean = false;
  persisting: boolean = false;

  constructor(
    private router: Router,
    public service: ArticoloService,
    private sharedService: SharedService,
    public parent: AppComponent) {

    this.sharedService.sharedEmitter.subscribe((o) => {
      console.log('Emitted data', o);

      // ============ AGGIORNAMENTO ROW MatTable ============
      if (o) {
        const _data = this.dataSource.data;
        let wndx = this.dataSource.data.findIndex(c => c._id == o._id);
        console.log('MATCH', wndx);
        if (wndx != -1) {
          _data[wndx] = o;
          console.log('MATCH object', _data[wndx]);
        }
          this.dataSource.data = _data;
      }
      // ============ AGGIORNAMENTO ROW MatTable ============
    })
  }

  search() {
    let wa = []
    this.filters.forEach(o => {
      wa.push(o.q)
    })
    this.filter.emit(wa);
  }

  edit() {
    this.router.navigate(['/articolo/' + this.service.selected]);
  }

  add() {
    this.router.navigate(['/articolo']);
  }

  remove() {
    if (this.service.selected) {
      this.persisting = true;
      this.parent.addToast('', 'eliminazione in corso...', ((wid) => {
        setTimeout(() => {
          let item2remove = new Articolo({
            _id: this.service.selected
          })
          this.service.remove(item2remove).subscribe((res) => {
            console.log(res)
            if (res.success) {
              this.confirm2remove = false;
            }
            this.parent.clearToast(wid);
            // this.filter.emit(this.filters);
            this.search();
            this.persisting = false;
            this.parent.operSnackBar(res.success, res.success ? 'eliminazione completata' : res.err)
          })
        }, 1000);
      }))
    }
  }

  addFilter(e) {
    console.log(e)
    if (e) {
      this.filters.push(e);
      this.activeFilter = '';
      this.search();
    }
  }

  removeFilter(f: any): void {
    let index = this.filters.indexOf(f);
    if (index >= 0) {
      this.filters.splice(index, 1);
      this.search();
    }
  }

  openFilter(f: any): void {
    console.log('******reopenFilter', f)
    this.filterModel[f.t.k] = f.o ? f.o : f.q.value;
    this.activeFilter = f.t.k;
    this.removeFilter(f);
  }

  shownFilter(s: string) {
    return this.filters.some(item => item.t.k === s);
  }

  highlight(_id) {
    this.service.selected = _id;
  }

  ngOnInit() {
    this.articoloDatabase = new MatTableCustomDao(this.service);
    this.dataSource = new MatTableCustomDataSource(
      this.articoloDatabase!,
      this.paginator,
      this.sort,
      this.filter,
      false);
  }

  getTitle(): string {
    return "articoli";
  }
}



// WEBPACK FOOTER //
// ./src/app/components/articolo/articolo-search/articolo-search.component.ts